import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { IOfferRegionListItem } from '../models/offer-region';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from './../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class RegionService {
  private url = environment.api;
  constructor(private http: HttpClient) {}

  getAllSwedishRegions(): Observable<IOfferRegionListItem[]> {
    const headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    const url = `${this.url}/offers/GetAllOfferRegions`;
    return this.http.get(url, { headers: headers }).pipe(
      map((data: any) => {
        return data;
      })
    );
  }
}
